// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax } from 'components/styles/_media'
import RoomCard, {
  type PropTypes as RoomCardTypes,
} from 'components/shared/RoomCard'
import RoomNotFound from 'components/molecules/room/RoomNotFound'

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  ${mediaMax.desktop`
    display: block;
  `};
`

const Item = styled.li`
  margin-bottom: 24px;
  width: 50%;

  &:nth-child(odd) {
    padding-right: 12px;
  }

  &:nth-child(even) {
    padding-left: 12px;
  }

  ${mediaMax.desktop`
    width: 100%;

    &:nth-child(odd) {
      padding-right: 0;
    }
    &:nth-child(even) {
      padding-left: 0;
    }
  `};
`

export default props => {
  if (props.totalCount > 0) {
    return (
      <List>
        {props.rooms.map((roomCardProps, index) => (
          <Item key={index}>
            <RoomCard
              {...roomCardProps}
              onClickFavorite={props.onClickFavorite}
            />
          </Item>
        ))}
      </List>
    )
  } else {
    return <RoomNotFound />
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/RoomList/index.jsx